import './tracking.style.sass';
import template from './tracking.tpl.pug';

class TrackingController {
    /* @ngInject */
    constructor($state) {
        this.$state = $state;
        
        this.options = [
            {
                id: 'spreadsheet',
                title: 'Spreadsheet',
                description: 'I use Excel, Google Sheets, or similar tools',
                icon: 'calendar'
            },
            {
                id: 'notes',
                title: 'Notes & Paper',
                description: 'I write down expenses in notes or on paper',
                icon: 'note-add'
            },
            {
                id: 'banking',
                title: 'Banking App',
                description: 'I check my bank app or statements',
                icon: 'wallet'
            },
            {
                id: 'none',
                title: 'No Tracking',
                description: 'I don\'t track my finances regularly',
                icon: 'help'
            }
        ];
    }

    selectOption(option) {
        this.selectedOption = option;
    }

    nextStep() {
        if (this.selectedOption) {
            this.onSubmit({ questionKey: 'tracking_method', answer: this.selectedOption.id });
            this.$state.go('conversion-quiz.goal');
        }
    }
}

export default {
    bindings: {
        onSubmit: '&'
    },
    template: template(),
    controller: TrackingController
};



// WEBPACK FOOTER //
// ./src/presentation/scene/conversion-quiz/steps/tracking/tracking.cmpt.js